import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, Chip } from '@mui/material';
import type { MessageEvent } from '@k-ucap/shared';
import { ValidationSeverity } from '@k-ucap/shared';

interface RecentMessagesProps {
  messages: MessageEvent[];
  onSelect?: (msg: MessageEvent) => void;
}

export const RecentMessages = ({ messages, onSelect }: RecentMessagesProps) => {
  return (
    <Paper sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Typography variant="subtitle2" gutterBottom>
        최근 송신 메시지 ({messages.length})
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Time</TableCell>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Direction</TableCell>
            <TableCell>Validation</TableCell>
            <TableCell>Seq</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {messages.map((msg) => (
            <TableRow
              key={msg.id}
              hover={Boolean(onSelect)}
              onClick={() => onSelect?.(msg)}
              sx={{ cursor: onSelect ? 'pointer' : 'default' }}
            >
              <TableCell>{new Date(msg.timestamp).toLocaleTimeString()}</TableCell>
              <TableCell>{msg.messageType}</TableCell>
              <TableCell>{msg.name}</TableCell>
              <TableCell>{msg.direction}</TableCell>
              <TableCell>
                <Chip
                  label={msg.validation || 'N/A'}
                  size="small"
                  color={
                    msg.validation === ValidationSeverity.PASS
                      ? 'success'
                      : msg.validation === ValidationSeverity.WARN
                        ? 'warning'
                        : 'default'
                  }
                />
              </TableCell>
              <TableCell>{msg.sequenceNumber ?? '-'}</TableCell>
            </TableRow>
          ))}
          {messages.length === 0 && (
            <TableRow>
              <TableCell colSpan={6}>
                <Typography variant="body2" color="text.secondary">
                  아직 송신된 메시지가 없습니다.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
};
